/**
 * Push-уведомления.
 *
 * Была заглушка «до фичи 2» — чат и есть эта фича. Интерфейс
 * isSupported/permission/requestPermission сохранён; добавлен
 * жизненный цикл подписки Web Push. В нативной сборке модуль
 * заменяется на FCM/APNs-реализацию — ради этого подписка
 * и разписка собраны здесь, а не размазаны по экранам.
 */

export const isSupported = () =>
  'Notification' in globalThis &&
  'serviceWorker' in (globalThis.navigator ?? {}) &&
  'PushManager' in globalThis

export const permission = () => globalThis.Notification?.permission ?? 'default'

export async function requestPermission() {
  if (!isSupported()) return 'unsupported'
  return await globalThis.Notification.requestPermission()
}

/**
 * VAPID public key приходит base64url — PushManager хочет Uint8Array.
 */
export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = globalThis.atob(base64)
  const output = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i)
  return output
}

/** Текущая подписка устройства либо null. */
export async function getSubscription() {
  if (!isSupported()) return null
  const reg = await globalThis.navigator.serviceWorker.ready
  return reg.pushManager.getSubscription()
}

/**
 * Подписаться. Возвращает subscription.toJSON() — ровно то,
 * что принимает POST /api/push/subscription.
 */
export async function subscribe(publicKey) {
  if (!isSupported()) throw new Error('Пуши не поддерживаются')
  const reg = await globalThis.navigator.serviceWorker.ready
  const sub = await reg.pushManager.subscribe({
    // Только видимые уведомления — иначе Chrome не даст разрешение.
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  })
  return sub.toJSON()
}

/** Отписаться. Возвращает endpoint снятой подписки либо null. */
export async function unsubscribe() {
  const sub = await getSubscription()
  if (!sub) return null
  const { endpoint } = sub
  await sub.unsubscribe()
  return endpoint
}
